import * as api from '../api'

//Action Creators
export const getTenantACEntries = () => async (dispatch) => {
  try {
    const { data } = await api.fetchTenantACEntries()
    dispatch({ type: 'FETCH_ALL_TENANT_AC_ENTRIES', payload: data })
  } catch (error) {
    dispatch({
      type: 'API_ERROR',
      payload: error.response.data.message,
    })
  }
}
